import { captureException } from '@sentry/react';
import { useGetContentPosts } from 'api/services/SupplierPortal/ContentManagementService';
import {
  ContentPost,
  ContentPostStatus,
  UXBContentCategory
} from 'portals/types';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { UXB_EVENT_KEY } from 'supplier-portals/uxbeauty/constants';

export const useContentData = <ResultType, PayloadType>(
  category: UXBContentCategory,
  mapper: (posts: ContentPost<PayloadType>[]) => ResultType[]
) => {
  const [result, fetchContentPosts] = useGetContentPosts<PayloadType>(
    UXB_EVENT_KEY,
    category
  );

  useEffect(() => {
    fetchContentPosts({
      params: {
        size: 200,
        status__icontains: ContentPostStatus.PUBLISHED
      }
    });
  }, [fetchContentPosts]);

  useEffect(() => {
    if (result.data && result.data.page.total_elements > 190) {
      captureException(
        new Error(
          `More than 190 events found for category '${category}'. Please check if it is still usable without performance issues.`
        )
      );
    }
  }, [category, result.data]);

  useEffect(() => {
    if (result.error)
      toast.error(`Failed to load content for category '${category}'`);
  }, [category, result.error]);

  return result.data?.content ? mapper(result.data.content) : undefined;
};
